import { render, staticRenderFns } from "./limit_details.vue?vue&type=template&id=2ac6dd64"
import script from "./limit_details.vue?vue&type=script&lang=js"
export * from "./limit_details.vue?vue&type=script&lang=js"
import style0 from "./limit_details.vue?vue&type=style&index=0&id=2ac6dd64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports